import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { STORE_NAMES } from '../../../constants/store.constants';

const DialPadHeader = ({ context }) => {
  const [headerTitle, setHeaderTitle] = useState('');
  const { headerText } = useSelector(state => state?.[STORE_NAMES.DIALPAD]);

  useEffect(() => {
    setHeaderTitle(headerText[context]);
  }, [context]);

  return <div className="vve-dialpad-header">{headerTitle}</div>;
};

DialPadHeader.propTypes = {
  context: PropTypes.string
};

export default DialPadHeader;
